import {ValueObject} from '@s-ui/domain'

export class LastDetailsViewedListValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array} data.items
   */
}
